import { PromotionBalanceEntryQualifier, PromotionTypes } from '@gongxigames/framework/promotions';
import { Action } from 'com/gongxigames/math/core/game/enums/Action';

export interface IPromotionLogicInterface {
    hasPromotion(): boolean;
    getType(): PromotionTypes;
    getID(): string;
    getBet(): number;
    getWin(): number;
    isActive(): boolean;
    isCurrentInUse(): boolean;
    isCurrentExpired(): boolean;
    shouldShowContinuePopup?(): boolean;
    init(data: any): void;
    update(data: any): void;
    subtractPromotion(): void;
    getRemainedRounds(): number;
    getPlayedRounds(): number;
    getTotalRounds(): number;
    getAdditionalFieldsForServerRequest(action: Action): Record<string, any> | undefined;
    getPingBalanceDelay?(): number;
    getQualifier(): PromotionBalanceEntryQualifier;
}
